(() => {
  const goal = 7500;
  let generation = 0;
  let timer;
  const update = (cart) => {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    const total = Math.max(0, Number(cart.total_price));
    for (const progress of document.querySelectorAll('[data-nz-free-shipping]')) {
      const currency = cart.currency || progress.dataset.currency;
      const text = progress.querySelector('[data-shipping-text]');
      const meter = progress.querySelector('[data-shipping-meter]');
      const fill = progress.querySelector('[data-shipping-fill]');
      if (!text || !meter || !fill) continue;
      meter.hidden = currency !== 'EUR';
      progress.classList.toggle('nz-free-shipping--complete', currency === 'EUR' && total >= goal);
      if (currency !== 'EUR') {
        text.textContent = progress.dataset.otherCurrencyText;
        continue;
      }
      const remaining = Math.max(0, goal - total);
      const amount = new Intl.NumberFormat(progress.dataset.locale || 'de', {
        style: 'currency', currency: 'EUR'
      }).format(remaining / 100);
      text.textContent = remaining === 0
        ? progress.dataset.completeText
        : progress.dataset.remainingText.replace('__amount__', amount);
      meter.setAttribute('aria-valuenow', String(Math.min(total, goal) / 100));
      meter.setAttribute('aria-valuetext', text.textContent);
      fill.style.transform = 'scaleX(' + Math.min(total / goal, 1) + ')';
    }
  };
  const refresh = () => {
    const current = ++generation;
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', {
          headers: { Accept: 'application/json' }, cache: 'no-store'
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (current === generation) update(cart);
      } catch {}
    }, 80);
  };
  document.addEventListener('nized:cart-rendered', (event) => {
    ++generation;
    clearTimeout(timer);
    update(event.detail?.cart);
  });
  document.addEventListener('cart:update', refresh);
  document.addEventListener('discount:update', refresh);
})();
